import { Head } from 'vite-react-ssg';
import { useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Container, Eyebrow } from '../components/ui-bits';
import { ListingCard } from '../components/ListingCard';
import { getCategory, listingsByCategory } from '../directory/data';

/** /discover/:category — listings within one activity. */
export default function Category() {
  const { category = '' } = useParams();
  const cat = getCategory(category);
  const listings = listingsByCategory(category);

  if (!cat) {
    return (
      <main>
        <Head><title>Not found | TechSoFit</title></Head>
        <Container>
          <p className="py-24 text-center text-muted">That activity does not exist. <a className="text-ink underline" href="/discover">Back to Discover</a></p>
        </Container>
      </main>
    );
  }

  return (
    <main>
      <Head>
        <title>{cat.label} near you | TechSoFit</title>
        <meta name="description" content={`${cat.label} near you. ${cat.blurb} Browse and find your next session on TechSoFit.`} />
      </Head>

      <section className="py-16 md:py-20">
        <Container>
          <a href="/discover" className="inline-flex items-center gap-1 text-sm text-muted hover:text-ink">
            <ChevronLeft className="size-4" /> All activities
          </a>
          <Eyebrow>Discover</Eyebrow>
          <h1 className="mt-3 font-display text-display-md text-ink">{cat.label}</h1>
          <p className="mt-4 max-w-2xl text-lg text-ink-soft">{cat.blurb}</p>

          {listings.length > 0 ? (
            <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {listings.map((l) => (
                <ListingCard key={l.slug} listing={l} />
              ))}
            </div>
          ) : (
            <p className="mt-8 rounded-card border border-dashed border-line bg-card/40 px-4 py-6 text-sm text-muted">
              No listings here yet. We are adding new places every week.
            </p>
          )}
        </Container>
      </section>
    </main>
  );
}
